import { Button, Dialog, DialogContent, DialogTitle, MenuItem, Typography, IconButton, Box, Divider, Paper, Grid } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close'; // Import the Close icon
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";

interface OrderDrawerProps {
    open: boolean;
    onClose: () => void;
    onSelectOrderType: (type: string) => void;  // Prop to pass selected order type back to parent
    selectedOrderType: string; // Track the currently selected order type
  }
  
  export const SelectOrderType: React.FC<OrderDrawerProps> = React.memo((props) => {
    const { open, onClose, onSelectOrderType, selectedOrderType } = props;
  
    const handleMenuItemClick = (item: string) => {
      onSelectOrderType(item); // Pass selected item back to parent
      onClose(); // Close the dialog after selection
    };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          width: '50rem', // Set your desired width
          height: '30rem', // Set your desired height (if needed)
          backgroundColor:"whitesmoke"
        },
      }}
    >
      <DialogTitle  sx={{backgroundColor:"green"}}>
        <Grid display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color={"white"}>Select Order Type</Typography>
          <IconButton onClick={onClose}>
            <WSIcons.CloseIcon sx={{color:"white"}}/>
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
      <Paper elevation={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem' }}>
  {['Dine-In', 'Delivery', 'Take-Away', 'Room Service'].map((item) => (
    <React.Fragment key={item}>
      <MenuItem
        onClick={() => handleMenuItemClick(item)}
        sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            backgroundColor: selectedOrderType === item ? 'green' : 'inherit', // Green if selected
            color: selectedOrderType === item ? 'white' : 'inherit', // White text if selected
            '&:hover': {
              backgroundColor: selectedOrderType === item ? 'green' : '#e0e0e0',
            },
          }}
      >
        {item}
      </MenuItem>
      <Divider sx={{ width: '100%' }} /> {/* Adjusts Divider to the full width */}
    </React.Fragment>
  ))}
</Paper>
      </DialogContent>
    </Dialog>
  );
});
